import { localStorageKeys } from "../../common/localstorages";
import { MENU_ITEMS, MenuItemType } from "../../common/menu-meta";
 
export class RouteUtils {
    static menuItems: MenuItemType[] = []
    static initMenu(userType: any, userSetting: any): any {
        this.menuItems = MENU_ITEMS
            .filter(menuItem =>
                menuItem.rolekey === userType &&
                userSetting.userPermissions.some((permission: any) =>
                    menuItem.moduleName === permission.module_name
                )
            )
            .map(menuItem => {
                if (!menuItem.children || menuItem.children.length === 0) {
                    // Find the matching permission and screen
                    let matchedScreenId = null;
                    userSetting.userPermissions.forEach((permission: any) => {
                        permission.screens.forEach((screen: any) => {
                            if (menuItem.screenName === screen.screen_name && screen.is_assigned) {
                                matchedScreenId = screen.screen_id;
                            }
                        });
                    });
                    const hasPermission = matchedScreenId !== null;
                    // Only return the menuItem if permission exists, and add screenId
                    return hasPermission ? { ...menuItem, screenId: matchedScreenId } : null;
                } else if (menuItem.children?.length) {
                    const filteredChildren = menuItem.children.map(child => {
                        let matchedScreenId = null;
                        userSetting.userPermissions.forEach((permission: any) => {
                            permission.screens.forEach((screen: any) => {
                                if (child.screenName === screen.screen_name && screen.is_assigned) {
                                    matchedScreenId = screen.screen_id;
                                }
                            });
                        });
                        return matchedScreenId !== null ? { ...child, screenId: matchedScreenId } : null;
                    }).filter(child => child !== null);
                    return filteredChildren.length > 0 ? { ...menuItem, children: filteredChildren } : null;
                }
                return null; // fallback safety
            })
            .filter(menuItem => menuItem !== null); // Remove nulls
        localStorage.setItem(
            localStorageKeys.MENUS,
            JSON.stringify(this.menuItems)
        );
return this.menuItems;
    }
}